import moment from 'moment'
import {getHardwareScreenType } from '../Helper/screenTypeHelpers'
import globalConfig from 'Helper/configHelpers'
const {heap_id: heapId } = globalConfig

// some of these cases are gen2 specific actions that should be moved out of
// the package
function log(state = {}, action) {
  const { event: actionEvent = {} } = action
  const {
    event,
    user_id: userId = state.user_id,
    timestamp = moment().format('YYYY-MM-DD HH:mm:ss'),
    patient_id: patientId = state.patientId,
    prescription_id: prescriptionId = state.prescriptionId,
    order_id = state.order_id,
    error
  } = actionEvent

  let newState
  let holding
  let newEvent

  switch (action.type) {
    case 'xtract-auth@reducer-logout':
      return {
        ...state,
        userId: null,
        patientId: null,
        prescriptionId: null
      }
    case 'STORE_ME_READ_ALL':
      // the currently logged in users info
      return {
        ...state,
        userId: action.result.user_id
      }
    case 'INIT_PATIENT_DISPLAY':
      return {
        ...state,
        patientId: action.patientId
      }
    case 'SET_PATIENT_DISPLAY_RX':
      return {
        ...state,
        prescriptionId: action.prescriptionId
      }
    case 'xtract-auth@update-log':
      return {
        ...state,
        holding: action.holding
      }
    case 'xtract-auth@add-to-log':
      newEvent = {
        event,
        user_id: userId,
        timestamp,
        patient_id: patientId ?? null,
        prescription_id: prescriptionId,
        order_id: order_id,
        error
      }
      holding = [...state.holding, newEvent]
      if(heapId) {
        heap.track(event, {
          user_id: userId,
          timestamp,
          patient_id: patientId ?? null,
          prescription_id: prescriptionId,
          order_id: order_id,
          error,
          systemType: getHardwareScreenType()
        })
      }
      return {
        ...state,
        holding
      }
    case 'CLEAR_PATIENT_DISPLAY':
      newState = { ...state }
      delete newState.patientId
      delete newState.prescriptionId
      return newState
    default:
      return state
  }
}

export default log
